var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 176,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.284 87.47c.104.032 18.008.032 53.712 0-3.185-8.409-8.252-10.895-15.202-7.46-.118-.489-.217-20.337-20.227-7.945-2.155.611-4.75.769-7.787.472-4.555-.446-12.367 7.54-10.496 14.933zM174 101.62h78.815c-.474-9.294-7.316-13.888-20.525-13.783l-.76-6.615c-.273-9.164-8.821-13.564-25.646-13.201-16.824.363-26.384 6.968-28.68 19.816L174 101.62z",
    stroke: "#084D8F",
    strokeWidth: 3,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.425 38.827c-.563-2.081-1.707-4.299-2.553-6.24C182.748 8.597 160.626 0 142.764 0 118.852 0 92.516 15.808 89 48.393v6.658c0 .277.097 2.773.235 4.022 1.971 15.529 14.4 32.033 23.681 47.562 9.987 16.638 20.349 33.005 30.615 49.365 6.33-10.676 12.637-21.493 18.823-31.893 1.686-3.052 3.643-6.102 5.331-9.015 1.125-1.94 3.274-3.88 4.256-5.685C181.927 91.382 198 73.217 198 55.328V47.98c0-1.94-2.438-8.734-2.575-9.152zM143.232 72c-7.1 0-14.87-3.47-18.706-13.056-.571-1.525-.525-4.583-.525-4.863v-4.305C124 37.556 134.613 32 143.845 32 155.21 32 164 40.89 164 52.002 164 63.113 154.598 72 143.232 72z",
    stroke: "#489AE1",
    strokeWidth: 3,
    fill: "#85CDFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.622 136.678c15.352-9.738 18.693-20.083 10.026-31.035-13.001-16.428-32.619 3.108-31.783 4.588l-2.823-.123c0-16.964-6.991-25.332-20.974-25.103-20.89.341-19.67 17.062-21.156 25.58v4.328h-10.17c-5.648 2.079-8.447 6.347-8.397 12.806l-6.005-.234c-5.292 3.075-5.744 5.974-1.358 8.695l1.639.509 91.001-.011z",
    stroke: "#084D8F",
    strokeWidth: 3,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 111.618L8.73 103M0 103l8.685 8.675",
    stroke: "#084D8F",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#084D8F",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 62.5,
    cy: 59.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#084D8F",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 252.5,
    cy: 117.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 141.037l8.201-9.037M215 132l8.911 9.088",
    stroke: "#084D8F",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EEE",
    cx: 143,
    cy: 167.5,
    rx: 78,
    ry: 6.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404-error.bbb748137579b6d12977a7b255ce2243.svg";
export { ForwardRef as ReactComponent };